// JsFromRoutes CacheKey e0f95b0a8a789bfbf24571bc84d53837
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/members/transactions'),
  show: /* #__PURE__ */ definePathHelper('get', '/members/transactions/:id'),
}
